<template>
  <div class="questions-component">
    <div v-for="(competency, index) in plansData" :key="index" class="competency-block">
      <p class="competency-title">
        {{ index + 1 }}. {{ competency.competency.name }}
      </p>
      <p class="competency-subtitle">
        Punto de mejora: {{ competency.improvement_plan }}
      </p>

      <div class="input-group">
        <label :for="'answer-' + index">Seleccione un porcentaje de cumplimiento:</label>
        <select
          :id="'answer-' + index"
          v-model="answers[index]"
          class="select-input"
        >
          <option value="" disabled>Seleccione un porcentaje</option>
          <option v-for="value in percentages" :key="value" :value="value">
            {{ value }} %
          </option>
        </select>
      </div>
    </div>

    <div class="input-group">
      <label for="comments">Comentario (opcional):</label>
      <textarea
        id="comments"
        v-model="comments"
        class="textarea-input"
        placeholder="Agrega un comentario sobre la evaluación..."
        maxlength="500"
      ></textarea>
      <p class="char-count">{{ comments.length }}/500</p>
    </div>

    <div class="button-container">
      <button
        type="button"
        @click="handleSubmit"
        :disabled="!allQuestionsAnswered"
        class="submit-button"
      >
        Guardar
      </button>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import request from "@/services/request";

export default {
  name: "evaluation-fill-plan",
  props: {
    plan: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      percentages: ["5","10","15","20","25","30","35","40","45","50","55","60","65","70","75","80","85","90","95","100"],
      answers: [],
      comments: "", 
    };
  },
  computed: {
    plansData() {
      return this.plan.competencies || [];
    },
    allQuestionsAnswered() {
      return this.plansData.every((_, index) => !!this.answers[index]);
    }
  },
  methods: {
    async handleSubmit() {
      if (!this.allQuestionsAnswered) {
        alert("Por favor, seleccione un porcentaje de cumplimiento para todas las competencias.");
        return;
      }

      const responsesPayload = this.plansData.map((competency, index) => ({
        competency_id: competency.id,
        percentage: this.answers[index],
        plan_id: this.plan.id,
        user_id: this.plan.user_id,
      }));

      try {
        const { data } = await request.post("/evaluations/competency-progress", {
          evaluation_id: this.plan.evaluation_id,
          user_id: this.plan.user_id,
          responses: responsesPayload,
          comments: this.comments || null, 
        });

        if (data) {
          this.successNotification("Evaluación guardada exitosamente.");
          this.$router.push({ path: '/evaluations/manager-evaluations', name: 'manager-evaluations' });
        }
      } catch (error) {
        console.error("Error al enviar la evaluación:", error);
        this.errorNotification("Hubo un error al enviar la evaluación. Por favor, inténtelo de nuevo.");
      }
    },
    ...mapActions({
      successNotification: 'alert/success',
      errorNotification: 'alert/error',
    }),
  },
};
</script>

<style scoped>
.questions-component {
  padding: 20px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.competency-block {
  margin-bottom: 20px;
}

.competency-title {
  font-size: 16px;
  font-weight: bold;
  color: #333;
  margin-bottom: 5px;
}

.competency-subtitle {
  font-size: 14px;
  font-style: italic;
  color: #666;
  margin-bottom: 10px;
}

.input-group {
  margin-bottom: 15px;
}

.select-input {
  width: 100%;
  padding: 8px;
  font-size: 14px;
  border: 1px solid #ccc;
  border-radius: 5px;
  outline: none;
}

.textarea-input {
  width: 100%;
  height: 80px;
  padding: 8px;
  font-size: 14px;
  border: 1px solid #ccc;
  border-radius: 5px;
  outline: none;
  resize: none;
}

.char-count {
  font-size: 12px;
  color: #666;
  text-align: right;
}

.button-container {
  text-align: right;
  margin-top: 20px;
}

.submit-button {
  background: #007bff;
  color: white;
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 14px;
}

.submit-button:disabled {
  background: #ccc;
  cursor: not-allowed;
}
</style>
